import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Feature } from './feature'
import type * as models from './models'
import type { State } from './state'

/**
 * Core actions for this {@link Feature}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    /**
     * If the current user is an employee in this zone, retrieves their employee
     * info
     */
    get: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<models.Employee>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          employee: { isLoading: true },
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          employee: { data: response },
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          employee: { error },
        }),
        cancellation: ({ state }) => ({
          ...state,
          employee: undefined,
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
